var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1588073211014,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 4426,
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M693.179733 520.8064c0 16.9984-13.7216 30.72-30.72 30.72h-122.88v116.053333c0 16.9984-13.7216 30.72-30.72 30.72s-30.72-13.7216-30.72-30.72v-116.053333h-116.053333c-16.9984 0-30.72-13.7216-30.72-30.72s13.7216-30.72 30.72-30.72h116.053333v-122.88c0-16.9984 13.7216-30.72 30.72-30.72s30.72 13.7216 30.72 30.72v122.88h122.88a30.72 30.72 0 0 1 30.72 30.72z",
    "p-id": 4427,
    fill: "#433938"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.918332e29b2bcb72568aecad27dd3d76.svg";
export { ForwardRef as ReactComponent };